import { Avatar } from 'antd';
import styled from 'styled-components';

export const StyledAvatar = styled(Avatar)`
    background-color: var(--gray-6);
`;
